import { useLocation, useHistory } from './WizardRouter';
/**
 * @typedef {Object} Wizard
 * @property {array} steps - Array of all the connected steps.
 * @property {string|number} activeStep - The ID of the current active step.
 * @property {number} activeStepIndex - Index of the current active step.
 * @property {function} goBack - Navigate backwards one step.
 * @property {boolean} canGoBack - Is there a previous step to navigate to?
 * @property {function} goForward - Navigate to the next step.
 * @property {boolean} canGoForward - Is there a next step to navigate to?
 * @property {function} goTo - Go to step based on step ID.
 * @property {function} canGoTo - Can you navigate to this step based on ID?
 */
/**
 * Get Wizard status.
 * @returns {Wizard} Wizard object.
 */
var useWizard = function () {
    var location = useLocation();
    var history = useHistory();
    var goBack = history.goBack, goForward = history.goForward, steps = history.entries;
    var activeStep = location.pathname;
    var getStepIndex = function (id) {
        return steps.map(function (step) { return step.pathname; }).indexOf("" + id);
    };
    var activeStepIndex = getStepIndex(activeStep);
    var canGoBack = history.canGo(-1);
    var canGoForward = history.canGo(1);
    var canGoTo = function (id) {
        var idIndex = getStepIndex(id);
        return history.canGo(idIndex);
    };
    var goTo = function (id) {
        var idIndex = getStepIndex(id);
        if (canGoTo(id)) {
            history.go(idIndex);
        }
    };
    return {
        steps: steps,
        activeStep: activeStep,
        activeStepIndex: activeStepIndex,
        goBack: goBack,
        canGoBack: canGoBack,
        goForward: goForward,
        canGoForward: canGoForward,
        goTo: goTo,
        canGoTo: canGoTo
    };
};
export default useWizard;
